"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tooltip = _interopRequireDefault(require("@mapbox/mr-ui/tooltip"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themes = _interopRequireDefault(require("../themes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Tag = /*#__PURE__*/function (_React$Component) {
  _inherits(Tag, _React$Component);

  var _super = _createSuper(Tag);

  function Tag() {
    _classCallCheck(this, Tag);

    return _super.apply(this, arguments);
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var theme = _themes.default[this.props.theme] || {
        label: this.props.customLabel,
        tooltipText: this.props.customTooltipText,
        styles: this.props.customStyles,
        icon: this.props.customIcon
      };
      return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        content: theme.tooltipText,
        maxWidth: "small",
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: theme.styles,
        className: (0, _classnames.default)('txt-bold round inline-block cursor-default', {
          'txt-s border': !this.props.small,
          'txt-xs': this.props.small,
          px6: !this.props.icon
        })
      }, this.props.icon ? /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: theme.icon,
        inline: true
      }) : theme.label));
    }
  }]);

  return Tag;
}(_react.default.Component);

exports.default = Tag;
Tag.defaultProps = {
  small: false,
  icon: false
};
Tag.propTypes = {
  theme: _propTypes.default.oneOf(['beta', 'fundamentals', 'legacy', 'new', 'custom']).isRequired,

  /** If `true`, display the tag with a smaller font and and no border */
  small: _propTypes.default.bool,

  /** If `true`, display the icon only (no text) */
  icon: _propTypes.default.bool,

  /** If the theme is set to "custom", this prop is required. */
  customLabel: function customLabel(props, componentName) {
    if (props.theme === 'custom' && !props.customLabel) {
      return new Error("The \"customLabel\" prop is required when using the \"custom\" theme in '".concat(componentName, "'."));
    } else if (props.theme === 'custom' && typeof props.customLabel !== 'string') {
      return new Error("The \"customLabel\" prop in '".concat(componentName, " must be a string'."));
    }
  },

  /* If the theme is set to "custom", this prop is required. */
  customTooltipText: function customTooltipText(props, componentName) {
    if (props.theme === 'custom' && !props.customTooltipText) {
      return new Error("The \"customTooltipText\" prop is required when using the \"custom\" theme in '".concat(componentName, "'."));
    } else if (props.theme === 'custom' && typeof props.customTooltipText !== 'string') {
      return new Error("The \"customTooltipText\" prop in '".concat(componentName, " must be a string'."));
    }
  },

  /* If the theme is set to "custom", this prop is required. */
  customStyles: function customStyles(props, componentName) {
    if (props.theme === 'custom') {
      if (!props.customStyles) {
        return new Error("The \"customStyles\" prop is required when using the \"custom\" theme in '".concat(componentName, "'."));
      } else if (_typeof(props.customStyles) !== 'object') {
        return new Error("The \"customStyles\" prop in '".concat(componentName, " must be an object'."));
      } else if (!props.customStyles.background || typeof props.customStyles.background !== 'string') {
        return new Error("The \"customStyles.background\" prop in '".concat(componentName, " is required when using the \"custom\" theme and must be a string'."));
      } else if (!props.customStyles.color || typeof props.customStyles.color !== 'string') {
        return new Error("The \"customStyles.color\" prop in '".concat(componentName, " is required when using the \"custom\" theme and must be a string'."));
      } else if (!props.customStyles.borderColor || typeof props.customStyles.borderColor !== 'string') {
        return new Error("The \"customStyles.borderColor\" prop in '".concat(componentName, " is required when using the \"custom\" theme and must be a string'."));
      }
    }
  },

  /** customIcon is required if using the "custom" theme and `icon=true` */
  customIcon: function customIcon(props, componentName) {
    if (props.theme === 'custom' && props.icon && !props.customIcon) {
      return new Error("The \"customIcon\" prop is required when using the \"custom\" theme and \"icon\" option in '".concat(componentName, "'."));
    } else if (props.customIcon && typeof props.customIcon !== 'string') {
      return new Error("The \"customIcon\" prop in ".concat(componentName, " must be a string'."));
    }
  }
};